import type { ComponentPropsWithRef } from 'react';
import { twMerge } from 'tailwind-merge';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

const badge = tv({
  base: [
    'px-2.5 py-0.5 bg-(--bg) rounded-md',
    'text-xs font-medium text-(--text) whitespace-nowrap',
  ],
  variants: {
    color: {
      primary: '[--bg:var(--color-primary-200)] [--text:var(--color-primary-900)]',
      secondary: '[--bg:var(--color-secondary-200)] [--text:var(--color-secondary-900)]',
      neutral: '[--bg:var(--color-secondary-200)] [--text:var(--color-secondary-900)]',
      info: '[--bg:var(--color-blue-200)] [--text:var(--color-blue-900)]',
      positive: '[--bg:var(--color-green-200)] [--text:var(--color-green-900)]',
      warning: '[--bg:var(--color-amber-200)] [--text:var(--color-amber-900)]',
      negative: '[--bg:var(--color-red-200)] [--text:var(--color-red-900)]',
    },
  },
});

type Color = VariantProps<typeof badge>['color'];

export function Badge({
  children,
  className,
  ref,
  color = 'primary',
  ...props
}: ComponentPropsWithRef<'div'> & { color?: Color }) {
  return (
    <div
      ref={ref}
      {...props}
      className={twMerge(badge({ color }), className)}
    >
      {children}
    </div>
  );
}
